import { titleUI } from 'platform/forms-system/src/js/web-component-patterns';
import ContactInfoDescription from '../../../components/FormDescriptions/VeteranContactInfoDescription';
import { emailUI, phoneUI } from '../../../definitions/sharedUI';
import content from '../../../locales/en/content.json';
import { FULL_SCHEMA } from '../../../utils/imports';

const TITLE_TEXT = content['vet-info-title--contact'];
const INPUT_LABEL = content['vet-input-label'];

const { email, phone } = FULL_SCHEMA.definitions;

export default {
  uiSchema: {
    ...titleUI(TITLE_TEXT, ContactInfoDescription),
    veteranPrimaryPhoneNumber: phoneUI(`${INPUT_LABEL} primary`),
    veteranAlternativePhoneNumber: phoneUI(`${INPUT_LABEL} alternative`),
    veteranEmail: emailUI(INPUT_LABEL),
  },
  schema: {
    type: 'object',
    required: ['veteranPrimaryPhoneNumber'],
    properties: {
      veteranPrimaryPhoneNumber: phone,
      veteranAlternativePhoneNumber: phone,
      veteranEmail: email,
    },
  },
};
